import styled from 'styled-components';
import {FILTER_ALL, FILTER_NONE, FILTER_CUSTOM} from '../../constants/filters';
import gql from 'graphql-tag';
import VirtualList from 'react-tiny-virtual-list';
import Grid from 'styled-components-grid';

const MUTATION_UPDATE_SETTINGS = gql`
  mutation updateSettings($input: UpdateSettingsInput!) {
    updateSettings(input: $input) {
      settings {
        id
        period {
          type
          range {
            start
            end
          }
        }
        workplaces {
          type
          ids
        }
        interruptingDisfunctions {
          type
          ids
        }
        notInterruptingDisfunctions {
          type
          ids
        }
        products {
          type
          ids
        }
        productStates {
          type
          ids
        }
        shifts {
          type
          ids
        }
      }
    }
  }
`;

const List = styled(VirtualList).attrs({
  height: '100%',
  width: '100%',
  itemSize: 54,
  overscanCount: 20,
})`
  height: ${({showheader}) => (showheader ? 'calc(100% - 54px) !important' : '100% !important')};
`;

const Row = styled(Grid)`
  height: 54px;
  align-items: center;
  text-align: ${({textAlign}) => (textAlign ? textAlign : 'left')};
  background: ${({theme, selected}) => (selected ? theme.primaryColor : theme.white)};
  border-bottom: 1px solid ${({theme, selected}) => (selected ? theme.white : theme.lightGray)};
  color: ${({theme, selected}) => (selected ? theme.white : theme.black)};
`;

const RowTitle = styled(Grid)`
  align-items: center;
  text-align: ${({textAlign}) => (textAlign ? textAlign : 'left')};
  background: ${({theme, selected}) => (selected ? theme.primaryColor : theme.white)};
  border-bottom: 1px solid ${({theme, selected}) => (selected ? theme.white : theme.lightGray)};
  color: ${({theme, selected}) => (selected ? theme.white : theme.black)};
  overflow-y: scroll;
  overflow-x: hidden;
  :height: 70px;
  min-height: 70px;
  max-height: 70px;
`;

const Item = styled(Grid.Unit)`
  padding: 0 ${({theme}) => theme.spacingHorizontal()};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemTitle = styled(Grid.Unit)`
  display: flex;
  align-items: center;
  padding: 5px ${({theme}) => theme.spacingHorizontal()};
  overflow-wrap: break-word;
  font-size: 0.85em;
  max-height: 68px;
  min-height: 68px;
  height: 68px;
`;

const Container = styled.div`
  min-width: 100%;
  overflow: auto;
  flex: 1;
`;

const ContainerTitle = styled.div`
  display: flex;
  min-width: 100%;
  overflow: auto;
  flex: 1;
  flex-direction: column;
`;

const Wrapper = styled.div`
  margin-bottom: ${({theme}) => theme.spacingHorizontal()};
  flex-direction: row;
  display: flex;
  overflow-y: auto;
  height: 50px; /* == min-height: 100px*/
`;

const Button = styled.button`
  padding: ${({theme}) => theme.spacingHorizontal()} ${({theme}) => theme.spacingVertical()};
  cursor: pointer;
  outline: none;
  border: 0;
  flex: 1;
  text-align: center;
  background-color: ${({theme, active, disabled}) =>
    disabled ? theme.white : active ? theme.primaryColor : theme.white};
  color: ${({theme, active, disabled}) => (disabled ? theme.black : active ? theme.white : theme.black)};
  &:hover {
    color: ${({theme, disabled}) => (disabled ? theme.black : theme.white)};
    background-color: ${({theme, disabled}) => (disabled ? theme.white : theme.primaryColor)};
  }
`;

const Input = styled.input`
  padding: ${({theme}) => theme.spacingHorizontal()} ${({theme}) => theme.spacingVertical()};
  outline: none;
  border: 0;
  text-align: left;
  background-color: ${({theme}) => theme.lightGray};
  color: ${({theme}) => theme.black};
`;

const getFilteredData = (items, search) => {
  let text = search.split(' ');
  return items.filter(function(item) {
    return text.every(function(el) {
      return JSON.stringify(item)
        .toLowerCase()
        .includes(el.toLowerCase());
    });
  });
};

const selectAll = (t, data, key, type) => {
  let temp = [];
  data.forEach((item) => temp.push(item[key]));
  updateSelect(t, temp, data, type);
};

const selectNone = (t, data, key, type) => {
  let temp = [];
  updateSelect(t, temp, data, type);
};

const select = (t, settings, id, data, key, type) => {
  let i;
  let temp = [];
  if (!settings.ids) {
    i = -1;
  } else {
    i = settings.ids.findIndex((t) => t === id);
    settings.ids.forEach((item) => temp.push(item));
  }
  if (i === -1) {
    if (settings.type === FILTER_ALL) {
      let w = [];
      data.forEach((item) => w.push(item[key]));
      const o = w.indexOf(id);
      if (o !== -1) w.splice(o, 1);
      updateSelect(t, w, data, type);
    } else {
      temp.push(id);
      updateSelect(t, temp, data, type);
    }
  } else {
    const l = temp.indexOf(id);
    if (l !== -1) temp.splice(l, 1);
    updateSelect(t, temp, data, type);
  }
};

const isSelected = (settings, id) => {
  if (settings.type === FILTER_ALL) return true;
  if (settings.type === FILTER_NONE) return false;
  if (settings.type === FILTER_CUSTOM && id !== null) {
    const c = settings.ids.findIndex((t) => t === id);
    return c !== -1 || settings.type === FILTER_ALL;
  }
};

const updateSelect = (t, temp, data, type) => {
  // Todo: remove for favorite settings saving implementation
  if (typeof t.props.favoriteId !== 'undefined') return;
  let v;
  if (temp.length === 0) v = FILTER_NONE;
  else if (temp.length === data.length) v = FILTER_ALL;
  else v = FILTER_CUSTOM;
  updateMutation(t, {
    [type]: {
      ids: v === (FILTER_ALL || FILTER_NONE) ? [] : temp,
      type: v,
    },
  });
};

const updateMutation = (t, data) => {
  t.props.client.mutate({
    mutation: MUTATION_UPDATE_SETTINGS,
    variables: {
      input: {
        settings: data,
      },
    },
  });
};

export {
  Container,
  ContainerTitle,
  Input,
  List,
  Row,
  RowTitle,
  Item,
  ItemTitle,
  Wrapper,
  Button,
  selectAll,
  selectNone,
  select,
  isSelected,
  updateMutation,
  getFilteredData,
};
